import React from 'react';

function ManageCategories() {
  return <h2>Manage Categories</h2>;
}

export default ManageCategories;
